import { RELAY_API_CONTENTFUL } from "@/utils/constant";

import {
    PricingPageRelayQuery,
    getPricingPageRelayQueryVars
} from "../contentful/graphql";
import { init as initRelay } from "../init-relay";
import { LoomPricingPage } from "../pages/software/loom/pricing/loom-pricing-page";

initRelay(
    LoomPricingPage,
    PricingPageRelayQuery,
    getPricingPageRelayQueryVars("loom", window.location),
    RELAY_API_CONTENTFUL
);
